const Result = ({ result }) => {
  return (
    <a href={result} target="_blank" rel="noreferrer">
      {result}
    </a>
  );
};

export default Result;
